<template>
  <div class="modal" @click.self="onClose">
    <div class="modal_content" :class="{ 'keyboard': isMobileOnly && showForm }">
      <div id="rename-me-03" @click.self="onClose">
        <div>
          <div>
            <p>{{ $t('save.transaction.number') }}</p>
            <p style="line-height: 1.1em">{{ getDisplayPaymentId }}</p>
            <dl>
              <dt>{{ $t('transaction.date') }}</dt>
              <dd><time>{{ transactionDate }}</time></dd>
              <dt>{{ $t('transaction.sum') }}</dt>
              <dd><span>{{ displayAmount }}</span></dd>
              <dt>{{ $t('transaction.recipient') }}</dt>
              <dd>{{ getDisplayProjectName }}, <a :href="`mailto:${getDisplayMerchantEmail}`">{{ getDisplayMerchantEmail }}</a></dd>
            </dl>
          </div>

          <div>
            <div v-if="checkSubscription" class="button" @click="goToSubscription">
              {{ $t('manage.subscription') }}
            </div>

            <div v-if="!showForm" class="button" @click="onShownForm">
              {{ $t('get.receipt') }}
            </div>

            <form v-show="showForm && !sended" @submit.prevent="goSend">
              <InputEmailPaid
                ref="customInput"
                v-model="email"
                inputId="input-id"
                :inputName="$t('common.mail')"
                inputTitle="inputId"
                :inputPlacehodler="$t('enter.email.for.receipt')"
              />
              <button
                :class="{
                  'loading': loading
                }"
                :disabled="!isValid"
                @click.prevent="goSend"
              >{{ $t('common.proceed') }}</button>
            </form>

            <div v-if="sended" v-show="showForm">
              <p>{{ responseText }}</p>
              <button @click.prevent="sended = false">{{ $t('common.more') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { isMobileOnly } from 'mobile-device-detect';
import { formatDateToCustomDate, getMomentDate } from 'lib/utils/date';
import { formatAmount } from 'lib/utils/amount';

import HTTPService from '@/services/Http';

export default {
  name: 'ModalPaidWithContent',
  data() {
    return {
      email: '',
      showForm: false,
      sended: false,
      loading: false,
      responseText: this.$t('receipt.sent'),
      isMobileOnly,
    };
  },
  computed: {
    displayAmount() {
      const { amount, currency } = this.TRANSACTION;

      return formatAmount(amount.amount, currency);
    },
    isValid() {
      return this.email && !this.loading && this.$refs.customInput.isValid;
    },
    // TODO: CPME-4085 доработать метод в геттерах для получения текущего объекта подписки
    checkSubscription() {
      const { billTariff } = this.TRANSACTION;

      if (!this.$validate.isObjectWithFields(billTariff, ['subscription'])) {
        return false;
      }

      if (this.$validate.isNull(billTariff.subscription)) {
        return false;
      }

      return true;
    },

    transactionDate() {
      if (!this.$validate.isObjectWithFields(this.TRANSACTION, ['created_at'])) {
        return formatDateToCustomDate(getMomentDate(), 'DD-MM-YYYY');
      }

      return formatDateToCustomDate(this.TRANSACTION.created_at, 'DD-MM-YYYY');
    },
    ...mapState(['TRANSACTION']),
    ...mapGetters([
      'getPaymentId',
      'getDisplayPaymentId',
      'getDisplayProjectName',
      'getDisplayMerchantEmail',
    ]),
  },
  methods: {
    goSend() {
      if (!this.isValid) {
        return;
      }

      this.sended = false;
      this.loading = true;

      const requestData = {
        email: this.email,
        paymentId: this.getPaymentId,
      };

      HTTPService.sendDigitalSellingReceipt(requestData)
        .then(() => {
          this.email = '';
          this.responseText = this.$t('receipt.sent');
        })
        .catch(() => {
          this.responseText = this.$t('receipt.not.sent');
        })
        .finally(() => {
          this.sended = true;
          this.loading = false;
        });
    },
    goToSubscription() {
      this.onClose();
      this.$router.push({ name: 'Subscription' });
    },
    onShownForm() {
      this.showForm = true;
    },
    onClose() {
      this.$emit('hide');
    },
  },
};
</script>

<style lang="sass" scoped>
  @mixin full-size($pos: absolute, $val: 0)
    position: $pos
    @if $val
      top: $val
      left: $val
      right: $val
      left: $val

  @mixin flex-center
    display: flex
    justify-content: center
    align-items: center

  .modal
    +full-size(fixed)
    +flex-center
    width: 100%
    height: 100vh
    z-index: 1000
    background: rgba(238, 238, 238, 0.65)
    overflow: hidden
    color: #212121

    .paiddigitalselling &
      background-color: rgba(0,0,0, .23)

  .modal_content
    width: 100%
    position: relative

    &.keyboard
      margin-top: -50%

  .button
    width: 100%
    padding: .96rem 2.48rem
    font-size: 1rem
    line-height: 1.44
    cursor: pointer
    color: #9B51E0
    background-color: #FFFFFF
    border-radius: 2.48rem
    border: 1px solid
    text-align: center
    transition: background .2s ease

    &:not(:last-child)
      margin-bottom: 10px

    &:hover
      color: #7CB342

    &:active
      background-color: #e1efd2
</style>
